<div class="op-debit-card-disclaimer" *transloco="let t">
	<div class="op-micro-font op-mb-20 op-dark-grey">
		<p class="policy" [innerHTML]="t('DEBIT_CARD_DISCLAIMER.availability')"></p>
	</div>
</div>
